import React from 'react';
import { useFieldValue } from 'Shared/utils/hooks';

export default function FeedbackComponent() {
  const currentWorkspace = useFieldValue('currentWorkspace');
  const workspaces = useFieldValue('workspaces');

  const { fullName } = workspaces.find(item => item.uuid === currentWorkspace);

  return (
    <div className="d-flex flex-column">
      <div className="d-flex mb-2 align-items-center justify-content-between">
        <p className="m-0">You gave {(fullName || '').split(' ')[0]} feedback!</p>
        <div className="badge badge-success">Example Feedback</div>
      </div>
      <div className="border shadow-sm rounded p-3">
        <p className="font-weight-bold border-bottom mb-1">I like that you...</p>
        <p className="mb-4">Take initiative on complicated projects</p>
        <p className="font-weight-bold border-bottom mb-1">I wish that you...</p>
        <p className="mb-0">Proactively shared updates with me</p>
      </div>
    </div>
  );
}
